import { http, HttpResponse } from 'msw';
import { faker } from '@faker-js/faker';

import { Profiles } from '@core/constants/profiles';

export const authHandlers = [
  http.post(`${import.meta.env.VITE_API_URL}/login`, async ({ request }) => {
    const { email } = (await request.json()) as { email: string };

    return HttpResponse.json({
      accessToken: faker.string.uuid(),
      message: 'User authenticated successfully',
      data: {
        user: {
          id: faker.string.uuid(),
          name: faker.person.fullName(),
          email,
          profile: Profiles.SUPERVISOR,
        },
        token: '3|RydHfVfSpA8ncQqbl06M1X6Ie9iUcmzKHWGEYx0F6f086a6b',
      },
    });
  }),
];
